import { render, staticRenderFns } from "./MultipleChoiceQuestions.vue?vue&type=template&id=3868bbe2&scoped=true"
import script from "./MultipleChoiceQuestions.vue?vue&type=script&lang=js"
export * from "./MultipleChoiceQuestions.vue?vue&type=script&lang=js"
import style0 from "./MultipleChoiceQuestions.vue?vue&type=style&index=0&id=3868bbe2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3868bbe2",
  null
  
)

export default component.exports